export default __webpack_public_path__ + "static/media/libtayo_banner_ad.b1e05374.png";